module.exports = require('./dist/logger').default;
